import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ServicesAdminList } from "@/components/services/ServicesAdminList";
import { apiSendJson } from "@/lib/sm-api";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";
import { toast } from "sonner";
import type { CommissionEntry } from "@/lib/db-service/service-commissions";

export const Route = createFileRoute("/app/liquidaciones")({
  component: Page,
  head: () => ({ meta: [{ title: "Liquidaciones" }] }),
});

function Page() {
  const tenantId = useWorkspaceTenantId();
  return (
    <ServicesAdminList<CommissionEntry>
      title="Liquidaciones"
      resource="commissions"
      screenId="liquidaciones"
      empty="No hay asientos de comisión."
      columns={[
        { key: "professionalName", label: "Profesional" },
        { key: "serviceName", label: "Servicio" },
        { key: "commissionAmount", label: "Monto" },
        { key: "commissionPct", label: "%" },
        { key: "paid", label: "Pagada", render: (r) => (r.paid ? "Sí" : "Pendiente") },
      ]}
      rowActions={(row, reload) =>
        row.paid ? null : (
          <Button
            size="sm"
            variant="outline"
            onClick={async () => {
              try {
                await apiSendJson(
                  `/api/service-admin?resource=commissions&id=${row.id}`,
                  "PATCH",
                  {},
                  tenantId,
                );
                await reload();
              } catch (err) {
                toast.error(err instanceof Error ? err.message : "Error");
              }
            }}
          >
            Marcar pagada
          </Button>
        )
      }
    />
  );
}
